import React, {} from "react"

const paths = require('../../../paths.json');

export default function bookmark_button_click(content_id, bookmark, data_func, post_data_func) {
   data_func(
      paths.BACKEND_URL + "api/set_user_favourite/"+content_id,
      "post",
      false,
      {
          'favourite': bookmark === true,
          // 'csrfmiddlewaretoken': csrf_token,
      },
      post_data_func,
  )
}
